module.exports = __webpack_public_path__ + "static/media/Tips on styling and formatting email link templates.d7f178da.png";